module.exports = __webpack_public_path__ + "img/mingyong85.d787d63c.png";